const PesquisaCpaRedunce = (state, action) => {
  switch (action.type) {
    case 'SET_PESQUISA_CPA':
      return {
        ...state,
        pesquisaCpa: action.payload,
      };
    default:
      return state;
  }
};

export default PesquisaCpaRedunce;
